import { createSelector } from 'reselect';
import { flow, get, pick } from 'lodash/fp';
import { getFormValues } from 'redux-form';

import { selectManufacturerOptions } from 'store/ducks/manufacturers';
import prepareFilterItems from './prepareFilterItems';
import sortFilterItemsAndUngroup from './toSortedFilters';
import { SEARCH_ADS_FORM } from '../../constants';
import { SORT_NAME } from '../../../constants';

const getBaseForm = createSelector(
  getFormValues(SEARCH_ADS_FORM),
  pick([SORT_NAME]),
);

export default createSelector(
  getBaseForm,
  get(['vehicle']),
  (state, props) => get(['filters'], props),
  selectManufacturerOptions,
  (baseForm, vehicle, filters, makeOptions) =>
    flow(prepareFilterItems(makeOptions), sortFilterItemsAndUngroup)(
      filters,
      baseForm,
      vehicle,
    ),
);
